import { Outlet, Route, Routes, useParams } from 'react-router'
import { ACCOUNT_PERMISSION } from '../../shared/constants'
import { useHasAccountPermission } from '../account-permissions'
import { ObjectTypes } from '../api/object'
import { ButtonLink } from '../components/button'
import { Tab } from '../components/tab'

const NAMES = {
	address: 'adresa',
	brand: 'firem',
	client: 'zákazníků',
	document: 'dokumentů',
	expense: 'plánovaných příjmů',
	location: 'poboček',
	reservation: 'rezervací',
	payment: 'přijatých příjmů',
	proposal: 'poptávek',
	proposal_vehicle: 'vozidel poptávek',
	vehicle: 'vozidel',
	user: 'uživatel',
} as const

export function Root() {
	return (
		<>
			<Routes>
				<Route path="/" element={<Main />} />
				<Route path="me/*" element={<Me />} />
				<Route path="roles/*" element={<Roles />} />
				<Route path="users/*" element={<Users />} />
				<Route path="reservation/*" element={<Reservations />}>
					<Route path="properties" element={<ReservationProperties />} />
					<Route path="layouts" element={<ReservationLayouts />} />
					<Route path="documents" element={<ReservationDocuments />} />
				</Route>
				<Route path=":object/*" element={<Objects />}>
					<Route
						path="properties"
						element={<ButtonLink to="./create">Přidat</ButtonLink>}
					/>
					<Route path="layouts" element={<ButtonLink to="./create">Přidat</ButtonLink>} />
				</Route>
			</Routes>
			<div className="grow">
				<Outlet />
			</div>
		</>
	)
}

function Main() {
	return (
		<div className="flex items-center gap-4 mb-5">
			<h2 className="text-lg">Nastavení</h2>
		</div>
	)
}

function Me() {
	return (
		<>
			<div className="flex items-center gap-4 mb-5">
				<h2 className="text-lg">Osobní nastavení</h2>
			</div>
			<div className="flex gap-4 p-4 justify-between items-center">
				<div className="flex gap-4 items-center min-h-10">
					<Tab to=".">Nastavení</Tab>
					<Tab to="identities">Identity</Tab>
				</div>
				<Outlet></Outlet>
			</div>
		</>
	)
}

function Roles() {
	return (
		<div className="mb-6 flex gap-4 justify-between items-center">
			<h2 className="py-4 text-lg">Nastavení rolí</h2>
			<ButtonLink to="./create">Přidat</ButtonLink>
		</div>
	)
}

function Users() {
	const canInviteUsers = useHasAccountPermission(ACCOUNT_PERMISSION.ADD_USERS)
	return (
		<div className="mb-6 flex gap-4 justify-between items-center">
			<h2 className="text-lg">Nastavení uživatelů</h2>
			<ButtonLink to="./invite" isDisabled={!canInviteUsers}>
				Přidat
			</ButtonLink>
		</div>
	)
}

function Objects() {
	const { object } = useParams<{ object: keyof ObjectTypes }>()
	if (!object) return

	return (
		<>
			<div className="flex items-center gap-4 mb-5">
				<h2 className="text-lg">
					Nastavení {object in NAMES ? NAMES[object as keyof typeof NAMES] : object}
				</h2>
			</div>
			<div className="flex gap-4 p-4 justify-between items-center">
				<div className="flex gap-4 items-center min-h-10">
					<Tab to="properties">Vlastnosti</Tab>
					<Tab to="layouts">Rozložení</Tab>
				</div>
				<Outlet />
			</div>
		</>
	)
}

function Reservations() {
	return (
		<>
			<div className="mb-6 flex gap-4 justify-between items-center">
				<h2 className="text-lg">Nastavení rezervací</h2>
			</div>
			<div className="flex gap-4 p-4 justify-between items-center">
				<div className="flex gap-4 items-center min-h-10">
					<Tab to="properties">Vlastnosti</Tab>
					<Tab to="layouts">Rozložení</Tab>
					<Tab to="documents">Dokumenty</Tab>
				</div>
				<Outlet />
			</div>
		</>
	)
}

function ReservationProperties() {
	const canAddProperties = useHasAccountPermission(ACCOUNT_PERMISSION.ADD_OBJECT_PROPERTIES)
	return (
		<ButtonLink to="./create" isDisabled={!canAddProperties}>
			Přidat
		</ButtonLink>
	)
}

function ReservationDocuments() {
	const canAddProperties = useHasAccountPermission(ACCOUNT_PERMISSION.ADD_DOCUMENTS)
	return (
		<ButtonLink to="./create" isDisabled={!canAddProperties}>
			Přidat
		</ButtonLink>
	)
}

function ReservationLayouts() {
	const canAddLayouts = useHasAccountPermission(ACCOUNT_PERMISSION.ADD_LAYOUTS)
	return (
		<ButtonLink to="./create" isDisabled={!canAddLayouts}>
			Přidat
		</ButtonLink>
	)
}
